import React from 'react'
import TableLayout from './TableLayout'
import styles from './WeekCalendar.less'
import _ from 'lodash'
import moment from 'moment'
export class WeekCalender extends React.Component {
  constructor (props) {
    super(props)
    this.state = { admin: false, Edit: false }
  }
  CancelRequest (d, p) {
    const { onCancelRequest } = this.props
    onCancelRequest(d.PayPeriod, p)
  }
  onChecked (d, p) {
    const { onSelected } = this.props
    onSelected(d.target, p)
  }
  onSelectAll (d) {
    const { onSelectAll } = this.props
    onSelectAll(d.target)
  }
  onContextMenu (d) {
    d.preventDefault()
    console.log(d)
  }
  onClick (p, w) {
    const { onClick } = this.props
    onClick(p, w)
  }
  onApprove (p, w) {
    const { onApprove } = this.props
    onApprove(p, w)
  }
  EditTime (p) {
    p.Edit = !p.Edit
    this.setState({ Edit: !this.state.Edit }, () => {
      const { EditTime } = this.props
      EditTime(p)
    })
  }
  onBlur (p) {
    const { EditTime } = this.props
    EditTime(p)
  }
  renderDay (d) {
    const { onClick } = this.props
    let sickhours = 0
    let SickApprovedDate = d.PayPeriod.SickApprovedDate
    let VacationApprovedDate = d.PayPeriod.VacationApprovedDate
    let CanceledSickRequest = (d.PayPeriod.SickRequestTime || 0) === 0 ? 0 : d.PayPeriod.SickRequestTime.Vaild
    let CanceledVacRequest = (d.PayPeriod.VacationRequestTime || 0) === 0 ? 0 : d.PayPeriod.VacationRequestTime.Vaild
    let SickApproved = !CanceledSickRequest ? 'Cancel' : d.PayPeriod.SickApproved
    let VacationApproved = !CanceledVacRequest ? 'Cancel' : d.PayPeriod.VacationApproved

    let vaccolor = !CanceledVacRequest ? '#FF0000' : (VacationApproved === 'Pending') ? '#F4EE00' : (VacationApproved === 'Approved') ? '#00B050' : (VacationApproved === 'Disapproved') ? '#FF0000' : null
    let sickcolor = !CanceledSickRequest ? '#FF0000' : (SickApproved === 'Pending') ? '#F4EE00' : (SickApproved === 'Approved') ? '#00B050' : (SickApproved === 'Disapproved') ? '#FF0000' : null
    let vacationischecked = {}
    let sickischecked = {}
    let SickRequestTime = (d.PayPeriod.SickRequestTime || 0) === 0 ? 0 : !CanceledSickRequest ? 0 : d.PayPeriod.SickRequestTime.CurrentlyRequesting
    let VacRequestTime = (d.PayPeriod.VacationRequestTime || 0) === 0 ? 0 : !CanceledVacRequest ? 0 : d.PayPeriod.VacationRequestTime.CurrentlyRequesting
    vacationischecked = VacRequestTime > 0 ? true : (d.Request || 0) === 0 ? 0 : (_.some(d.Request, (e) => { return e.ischecked && e.Type === 3 }))
    sickischecked = SickRequestTime > 0 ? true : (d.Request || 0) === 0 ? 0 : (_.some(d.Request, (e) => { return e.ischecked && e.Type === 2 }))
    sickhours = (SickRequestTime || 0) + (VacRequestTime || 0)
    let PreviousPayPeriod = (d.PayPeriod.PreviousPayPeriod || 0) === 0 ? '' : moment(d.PayPeriod.PreviousPayPeriod[0].substring(0, 10)).add('days', -1)
    // let canpickvac = (d.PayPeriod.DefaultVac || 0) === 0 ? false : d.PayPeriod.DefaultVac.Remaining > 0
    // let canpicksick = (d.PayPeriod.DefaultSick || 0) === 0 ? false : d.PayPeriod.DefaultSick.Remaining > 0
    let Total = Math.floor(d.PayPeriod.TimePunchesTotals / 60)
    Total = Total + sickhours
    let showAddTask = _.some(d.PayPeriod.TimePunches, (e) => {
      return e.SubmitDate !== null
    })
    return (
      <div className={styles.rowwrapper} style = {{ color: `${d.PayPeriod.IsComplete && moment(d.PayPeriod.Date) <= moment().add('day', 1) && Total ? '#FFF' : moment(d.PayPeriod.Date) <= moment().add('day', 1) && Total ? '#000' : null}`, background: `${d.PayPeriod.IsComplete && moment(d.PayPeriod.Date) <= moment().add('day', 1) && Total ? '#00B050' : moment(d.PayPeriod.Date) <= moment().add('day', 1) && Total ? '#D3D2D2' : null}` }}>
        <div className={styles.daywrapper}>
          <div style = {{ gridColumn: 1 }} >
            <div > {d.PayPeriod.Day} </div>
            <div > {d.PayPeriod.Date.substring(0, 10)} </div>
          </div>
          <div className={styles.checkBox} style = {{ gridColumn: 2 }}>
            {!showAddTask && PreviousPayPeriod < moment(d.PayPeriod.Date.substring(0, 10)) // (moment(d.PayPeriod.Date) >= moment() || VacRequestTime)  ?
              ? <div className={styles.round} style = {{ gridRow: 1 }} >
             Vacation
                <input id={`${d.PayPeriod.Date}Vcheckbox`} className={styles.round} checked={vacationischecked || VacRequestTime} onClick={(e) => { this.onChecked(e, d) }} value="3" type = "checkbox"
                  name={`VacCheckBox${d.Date}`}
                  style = {{ marginLeft: '10px' }}/>
                <label htmlFor={`${d.PayPeriod.Date}Vcheckbox`}>
                </label>
              </div> : null
            }
            { (moment(d.PayPeriod.Date) <= moment() || SickRequestTime) && !showAddTask && PreviousPayPeriod < moment(d.PayPeriod.Date.substring(0, 10))
              ? <div className={styles.round} style = {{ gridRow: 2 }} >
              Sick
                <input id={`${d.PayPeriod.Date}Scheckbox`} checked={sickischecked || SickRequestTime} value="2" onClick={(e) => { this.onChecked(e, d) }} type = 'checkbox'
                  name={`SickCheckBox${d.Date}`} style = {{ marginLeft: '48px' }}/>
                <label htmlFor={`${d.PayPeriod.Date}Scheckbox`}>
                </label>
              </div>
              : null
            }
          </div>
          <div style = {{ gridColumn: 3, width: '150px' }}>
            { VacRequestTime && SickRequestTime ? <div>Sick: {SickRequestTime} Vacation: {VacRequestTime}  </div> : null }
            { sickhours ? <div>Total: {sickhours} </div> : null }
          </div>

          {/* {_.map(d.TimePunches, (q) => {
          return (<div className={styles.timewrapper} style = {{gridColumn: 4}}>  {q.StartTime.substr(q.EndTime.length - 12)} - {q.EndTime.substr(q.EndTime.length - 12)}  </div>)
        })} */}
          { Total ? <div style = {{ gridColumn: 4, gridRow: 1 }}>{Total} Hours</div> : null }
          {/* <div style = {{gridColumn: 4, gridRow: 2}}>{Total} </div> */}
          <div style = {{ gridColumn: 5 }}>
            { SickRequestTime
              ? <div style={{ display: 'Grid', gridTemplateColumns: '2fr 1fr', textAlign: 'center' }}>
                <div onClick={this.CancelRequest.bind(this, d, 2)} style={{ margin: '3px', cursor: 'pointer', borderRadius: '100px', background: sickcolor, color: '#FFFF' }}>Sick {SickApproved}</div>
                <div style={{ paddingLeft: '5px' }}>{SickApprovedDate}</div>
              </div>
              : null }
            { VacRequestTime
              ? <div style={{ display: 'Grid', gridColumnGap: '5px', gridTemplateColumns: '1fr .5fr', textAlign: 'center' }}>
                <div onClick={CanceledVacRequest ? this.CancelRequest.bind(this, d, 3) : null}
                  style={{ cursor: CanceledVacRequest ? 'pointer' : null, margin: '3px', borderRadius: '100px', background: vaccolor, color: '#FFFF' }}>Vacation {VacationApproved}</div>
                <div> {VacationApprovedDate}</div>
              </div>
              : null }
          </div>
          { moment(d.PayPeriod.Date) <= moment().add('day', 1) && PreviousPayPeriod < moment(d.PayPeriod.Date.substring(0, 10))
            ? d.PayPeriod.SubmittedDate ? null
              : <button onClick={onClick.bind(this, d.PayPeriod.TimePunches.length > 0 ? d.PayPeriod.TimePunches : d.PayPeriod)} className={styles.timepunchbutton} style= {{ gridColumn: 6 }}>View Task</button>
            : null
          }
        </div>
      </div>
    )
  }
  renderHeader () {
    const { TimePunches } = this.props
    let Status = (TimePunches || 0) === 0 ? false : 1
    let TotalHours = (TimePunches || 0) === 0 ? false : _.some(TimePunches, (e) => { return e.PayPeriod.TimePunchesTotals > 0 })
    let RequestedHours = (TimePunches || 0) === 0 ? false : _.some(TimePunches, (e) => { return e.VacationRequestTime !== null || e.SickRequestTime !== null })
    return (
      <div className={styles.daywrapper}>
        <div style = {{ gridColumn: 1 }}>
         Dates
        </div>
        <div style = {{ gridColumn: 2 }}>
         Types
        </div>
        { RequestedHours ? <div style = {{ gridColumn: 3 }}>Requested Hours</div> : null }
        { TotalHours ? <div style = {{ gridColumn: 4 }}>Total Hours</div> : null }
        { Status ? <div style = {{ gridColumn: 5 }}>  Status </div> : null }
        <div style = {{ gridColumn: 6 }}>
        </div>
      </div>

    )
  }
  renderRequestHeader () {
    return (
      <div className={styles.requestdayheaderwrapper}>
        <div style = {{ gridColumn: 1, Width: '145px' }}>
         Dates
        </div>
        <div style = {{ gridColumn: 2 }}>
         Types
        </div>
        <div style = {{ gridColumn: 3 }}>
         User
        </div>
        <div style = {{ gridColumn: 4 }}>
        Request Amount
        </div>
        <div style = {{ gridColumn: 5 }}>
        RequestDate
        </div>
      </div>
    )
  }
  renderRequest (d) {
    return (
      <div className={styles.rowwrapper}>
        <div className={styles.requestdaywrapper}>
          <div style = {{ gridColumn: 1, maxWidth: '145px' }} >
            <div > {moment(d.StartDate).format('dddd')}  </div>
            <div > {moment(d.StartDate).format('MMM Do YY')} </div>
          </div>

          <div style = {{ gridColumn: 2 }}>
            { d.Type === 2 ? <div style = {{ margin: '0 20px' }}>Sick</div> : <div>Vacation</div> }
          </div>
          <div style = {{ gridColumn: 3 }}>
            <div>
              {d.PersonName}
            </div>
          </div>
          <div style = {{ gridColumn: 4 }}>
        Amount:<div>{d.RequestAmount}</div>
          </div>
          <div style = {{ gridColumn: 5 }}>
          Requested on:<div>{moment(d.RequestDate).format('MMM ddd Do YY')}</div>
          </div>
          <div style = {{ gridColumn: 6 }}>
            <button onClick={this.onClick.bind(this, d, true)} className={styles.approvebutton}><i className={`${styles.addmargin} far fa-check-circle`}></i></button>
            <button onClick={this.onClick.bind(this, d, false)} className={styles.denybutton} ><i className={`${styles.addmargin} far fa-window-close`}></i></button>
          </div>
          <div style = {{ gridColumn: 7, margin: '10px' }}>
            <label><span>Comments:</span>
              <input style = {{ marginLeft: '10px' }} type='text' />
            </label>
          </div>
        </div>
      </div>
    )
  }
  renderSheetsHeader () {
    const { TimeSheets, ApproveAll } = this.props
    return (
      <div>
        { _.some(TimeSheets, (x) => {
          return x.StartDate
        }) ? <div style={{ display: 'none' }}/>
          : <div className={styles.sheetsdayheaderwrapper} >
            <div className={styles.sheetsdayname} >
              {TimeSheets ? 'Name' : 'Start Date'}
            </div>
            <div className={styles.sheetsdaydate} >
              <div>{TimeSheets ? (_.some(TimeSheets, (x) => { return moment(x.StartTime, '0001-01-01T00:00:00Z', true).isValid() }) ? null : 'Date') : <div/>}</div>
            </div>
            <div className={styles.sheetsdaytime} >
              {_.some(TimeSheets, (x) => { return (moment(x.StartTime, '0001-01-01T00:00:00Z', true).isValid()) }) ? '' : 'Time'}
            </div>
            <div className={styles.sheetsdayhours} >
             Total Hours
            </div>
            <div className={styles.sheetsdayregularhours} >
              {
                _.some(TimeSheets, (d) => {
                  return moment(d.StartTime, '0001-01-01T00:00:00Z', true).isValid() ? true : (moment(d.StartTime, '0001-01-01T00:00:00Z', true).isValid()
                    ? true : moment(d.StartTime, '0001-01-01T00:00:00Z', true).isValid())
                }) ? 'Regular Hours' : '' }
            </div>
            <div className={styles.sheetsdayholidayhours} >
              {
                _.some(TimeSheets, (d) => {
                  return (d.VacSum && d.SickSum) && moment(d.StartTime, '0001-01-01T00:00:00Z', true).isValid() ? true : (d.VacSum && moment(d.StartTime, '0001-01-01T00:00:00Z', true).isValid()
                    ? true : !!d.SickSum && moment(d.StartTime, '0001-01-01T00:00:00Z', true).isValid())
                }) ? 'Vacation Hours' : '' }
            </div>
            <div className={styles.sheetsdaycommission} >
              {_.some(TimeSheets, (x) => { return moment(x.StartTime, '0001-01-01T00:00:00Z', true).isValid() }) ? '' : 'Commission'}
            </div>
            <div className={styles.sheetsdaybonus} >
              {_.some(TimeSheets, (x) => { return moment(x.StartTime, '0001-01-01T00:00:00Z', true).isValid() }) ? '' : 'Bonus'}
            </div>
            <div className={styles.sheetsdaybtn} >
              {TimeSheets ? <button className={styles.approvebutton} onClick={ApproveAll.bind(this)} style = {{ background: '#00B050', width: '115px' }}>Approve All</button> : null }
            </div>
          </div>
        }
      </div>
    )
  }
  renderSheets (d) {
    const { isUser } = this.props
    let Total = (d.Sum / 60).toFixed(2) // d.Sum === 0 ? (d.VacSum / 60).toFixed(2) : (d.Sum / 60).toFixed(2)
    let holidaySum = (d.VacSum && d.SickSum) ? ((d.VacSum / 60).toFixed(2) + (d.SickSum / 60).toFixed(2)) : (d.VacSum ? (d.VacSum / 60).toFixed(2) : (d.SickSum / 60).toFixed(2))

    // var EndTimeUtc = moment.utc(d.EndTime).toDate()
    // var StartTimeUtc = moment.utc(d.StartTime).toDate()
    var EndTimelocal = moment(d.EndTime).local().format('YYYY-MM-DD HH:mm:ss')
    var StartTimelocal = moment(d.StartTime).local().format('YYYY-MM-DD HH:mm:ss')

    let show = (moment(d.StartTime, '0001-01-01T00:00:00Z', true).isValid() === true)
    let sum = (Number(holidaySum) + Number(Total))
    return (
      <div className={styles.rowsheetswrapper} style={{ margin: 0, padding: 0 }}>
        {d.PersonName
          ? <div className={styles.peoplesheetsdaywrapper}>
            <div className={styles.sheetsdayname} >
              <div>{d.PersonName}</div>
            </div>
            <div className={styles.sheetsdaydate} >
              {show ? <div /> : <div >{moment(StartTimelocal).format('MM/DD/YYYY')}</div> }
            </div>
            { show
              ? <div className={styles.sheetsdaytime} style = {{ gridColumn: 3, gridRow: 1, textAlign: 'center' }} >
                <div/>
              </div>
              : (d.Type === 2) || (d.Type === 3)
                ? <div className={styles.sheetsdaytime} style = {{ gridColumn: 3, gridRow: 1, textAlign: 'center' }} >
                  <div/>
                </div>
                : <div className={styles.sheetsdaytime} style = {{ gridColumn: 3 }}>
                  {d.Edit ? <label className={styles.editlabelstyle}>
                    <input type = "text" onChange={(e) => {
                      d.StartTime = moment(moment(StartTimelocal).format('YYYY-MM-DD ') + moment(e.target.value, 'hh:mm a').format('HH:mm:ss') + ' -05:00').utc().format('YYYY-MM-DD HH:mm:ss')
                      d.Sum = moment(d.EndTime).diff(moment(d.StartTime), 'minute')
                    }}
                    defaultValue = {`${moment(StartTimelocal).format('h:mm:ss a')}`}
                    className={styles.editlabelstyle}/>
                    <input type = "text" onChange={(e) => {
                      d.EndTime = moment(moment(EndTimelocal).format('YYYY-MM-DD ') + moment(e.target.value, 'hh:mm a').format('HH:mm:ss') + ' -05:00').utc().format('YYYY-MM-DD HH:mm:ss')
                      d.Sum = moment(d.EndTime).diff(moment(d.StartTime), 'minute')
                    }}
                    defaultValue = {`${EndTimelocal ? `${moment(EndTimelocal).format('h:mm:ss a')}` : <div style = {{ gridColumn: 5 }}/>}`}
                    className={styles.editlabelstyle}/></label>
                    : <span>
                      {moment(StartTimelocal).format('h:mm:ss a')}
                      { EndTimelocal ? ` - ${moment(EndTimelocal).format('h:mm:ss a')}` : <div style = {{ gridColumn: 5 }}/>}
                    </span>
                  }
                  <button onClick={this.EditTime.bind(this, d)}
                    style = {{ gridRow: 1 }}
                    className={`${styles.plusbutton} ${d.Edit ? 'fas fa-plus-circle' : 'fas fa-edit'}`}
                  />
                </div>
            }
            <div className={styles.sheetsdayhours} >
              <div style={{ minWidth: '150px', textAlign: 'center' }}>{sum}</div>
            </div>
            <div className={styles.sheetsdayholidayhours } >
              {holidaySum > 0
                ? <div style={{ minWidth: '150px', textAlign: 'center' }}>{holidaySum}</div> : <div/>}
            </div>
            <div className={styles.sheetsdayregularhours } >
              {moment(d.StartTime, '0001-01-01T00:00:00Z', true).isValid()
                ? <div style={{ minWidth: '150px', textAlign: 'center' }}>{Total}</div> : <div/>}
            </div>
            {show ? <div />
              : <div className={styles.sheetsdaycommission} >
                <label className={styles.editlabelstyle}>
                  <input
                    onChange={(e) => { d.Commission = e.target.value }}
                    onBlur = {this.onBlur.bind(this, d)}
                    defaultValue = {d.Commission}
                    style={{ maxWidth: '125px', textAlign: 'center' }} type = "text" /></label>
              </div>
            }
            {show ? <div />
              : <div className={styles.sheetsdaybonus} >
                <label className={styles.editlabelstyle}>
                  <input
                    onChange={(e) => { d.Bonus = e.target.value }}
                    defaultValue = {d.Bonus}
                    onBlur = {this.onBlur.bind(this, d)}
                    style={{ maxWidth: '125px', textAlign: 'center' }} type = "text" /></label>
              </div>
            }
            {d.Sum > 0
              ? isUser ? <div className={styles.sheetsdaybtn} >
                <button onClick={this.onApprove.bind(this, d)} className={styles.approvebutton} ><i className="far fa-check-circle"></i></button>
              </div>
                : <div className={styles.sheetsdaybtn} >
                  <button onClick={this.onClick.bind(this, d, false)} className={styles.editbutton} ><i className='fas fa-edit'></i></button>
                </div> : <div className={styles.sheetsdaybtn} />
            }
          </div>
          : <div/>}
      </div>
    )
  }
  render () {
    const { TimePunches, Request, TimeSheets, onBackClick } = this.props
    const columns = [{
      Header: 'Start Date',
      accessor: 'startdate',
      filter: 'fuzzyText'
    }, {
      Header: 'End Date',
      accessor: 'enddate',
      sortable: false,
      filterable: false,
      canFilter: false
    }, {
      Header: 'Pay Date',
      accessor: 'paydate'
    }, {
      Header: 'Status',
      accessor: 'status'
    },
    {
      Header: '',
      accessor: 'button'
    }
    ]
    const data = _.map(TimeSheets, (d) => {
      return {
        startdate: moment(d.StartDate).format('MM/DD/YYYY'),
        enddate: moment(d.EndDate).format('MM/DD/YYYY'),
        paydate: moment(d.PayDateDate).format('MM/DD/YYYY'),
        status: d.Payed ? 'Complete' : 'Open',
        button: <button className={styles.editbutton} onClick={this.onClick.bind(this, d, false)}><i className={`far fa-edit`} ></i></button>
      }
    })

    return (
      <div className={styles.wrapper}>
        {(TimeSheets) ? _.some(TimeSheets, (x) => { return x.StartDate }) ? null : <div>
          <button onClick={onBackClick} className={`${styles.backbutton} fas fa-arrow-left`}> <span>Back</span></button>
          <div className={styles.hourswrapper}>
            <span>Regular - {(_.sumBy(TimeSheets, (x) => { return x.Sum }) / 60).toFixed(2)} hrs</span>
            <span> Holiday - {Math.floor((_.sumBy(TimeSheets, (x) => { return x.VacSum }) / 60)).toFixed(2) || 0}hrs</span>
            <span> Overtime - {0}hrs</span>
          </div>
        </div>
          : null}
        <div className={styles.weekwrapper}>
          <div style={{ margin: 'none' }}>
            { (TimePunches) ? this.renderHeader() : null}
          </div>

          { (TimePunches) ? <div>{_.map(TimePunches, (d) => { return (this.renderDay(d)) }) }</div>
            : (Request) ? <div>{_.map(Request, (d) => { return (this.renderRequest(d)) }) }</div>
              : (_.some(TimeSheets, (x) => {
                return x.StartDate
              })) ? <TableLayout headerstyle={{ color: 'white', background: '#6F6F6F' }} style={{ }} mainstyle={{ maxHeight: '80vh', overflowY: 'auto', overflowX: 'hidden' }}
                  GetCurrentOpen = {this.GetCurrentOpen.bind(this)}
                  columns = {columns} data={data}></TableLayout> : <div>{this.renderSheetsHeader()} {_.map(TimeSheets, (d) => { return (this.renderSheets(d)) }) } </div>
          }

        </div>
      </div>
    )
  }
  GetCurrentOpen (data) {
    const { onClick } = this.props
    onClick.bind(this, data)
  }
}
